import React from "react"
import AccessPage from "components/pages/access"

const AccessEn = (props) => <AccessPage {...props} />

export default AccessEn